import React from "react";
import type { RouteObject } from "react-router-dom";
import AdminRequiredWrapper from "src/pages/agent/AgentRequiredWrapper";
import MariaPage from "src/pages/admin/maria/mariaPage";
import Dashboard from "src/pages/admin/maria/dashboard";

const mariaRouter: RouteObject[] = [
  {
    path: "maria",
    element: (
      <AdminRequiredWrapper>
        <MariaPage />
      </AdminRequiredWrapper>
    ),
    children: [
      {
        index: true,
        element: (
          <AdminRequiredWrapper>
            <Dashboard />
          </AdminRequiredWrapper>
        ),
      },
    ],
  },
];

export default mariaRouter;
